import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96eba98a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "recorder__label" }, " Aufnahme starten ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "recorder__btn" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-microphone-alt" })
], -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "recorder__recording"
}
const _hoisted_5 = { class: "recorder__frequencies" }
const _hoisted_6 = { ref: "frequencies" }
const _hoisted_7 = { class: "recorder__recording-info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "recorder__recording-text" }, "Aufnahme läuft…", -1))
const _hoisted_9 = { class: "recorder__timer" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pause" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-microphone-alt" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-stop" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "recorder__playback"
}
const _hoisted_17 = {
  key: 0,
  class: "recorder__actions"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fad fa-save" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "recorder__action-label" }, "Speichern und teilen", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "recorder__action"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "recorder__action-label" }, "Bitte warten…", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fad fa-redo" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "recorder__success" }, " Aufnahme gespeichert! Du kannst sie nun über den folgenden Link teilen: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Player = _resolveComponent("Player")!
  const _component_ShareRecording = _resolveComponent("ShareRecording")!
  const _component_Error = _resolveComponent("Error")!
  const _component_TermsOfUse = _resolveComponent("TermsOfUse")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["recorder", {'recorder--unavailable': _ctx.unavailable}])
  }, [
    (_ctx.state === 'initial')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "recorder--init",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.start()), ["prevent"]))
        }, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.state === 'recording')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("canvas", _hoisted_6, null, 512)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.elapsedRecordingTime()), 1)
          ]),
          (!_ctx.paused)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "recorder__btn recorder__btn--pause",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.pause()), ["prevent"])),
                href: "",
                title: "Pause"
              }, _hoisted_11))
            : _createCommentVNode("", true),
          (_ctx.paused)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "recorder__btn recorder__btn--pause",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.resume()), ["prevent"])),
                href: "",
                title: "Weiter aufnehmen"
              }, _hoisted_13))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            class: "recorder__btn recorder__btn--stop",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.stop()), ["prevent"])),
            href: "",
            title: "Stop"
          }, _hoisted_15)
        ]))
      : _createCommentVNode("", true),
    (_ctx.state === 'playback')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_Player, {
            audio: _ctx.recorder.getAudio()
          }, null, 8, ["audio"]),
          (!_ctx.recordingId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (!_ctx.saving)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.save()), ["prevent"])),
                      href: "",
                      class: "recorder__action"
                    }, _hoisted_20))
                  : (_openBlock(), _createElementBlock("span", _hoisted_21, _hoisted_24)),
                _createElementVNode("a", {
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.reset()), ["prevent"])),
                  href: "",
                  class: "recorder__action",
                  title: "Nochmals aufnehmen"
                }, _hoisted_26)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_27,
                _createVNode(_component_ShareRecording, { id: _ctx.recordingId }, null, 8, ["id"])
              ], 64))
        ]))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_Error, {
          key: 3,
          error: _ctx.error
        }, null, 8, ["error"]))
      : _createCommentVNode("", true),
    (_ctx.showTerms)
      ? (_openBlock(), _createBlock(_component_TermsOfUse, {
          key: 4,
          onAccept: _cache[6] || (_cache[6] = ($event: any) => (_ctx.acceptTerms()))
        }))
      : _createCommentVNode("", true)
  ], 2))
}